<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">This book is dedicated to my newsletter group,</p>
<p class="center"><em>the Femmes Fatale,</em></p>
<p class="center"><em>who make me laugh</em></p>
<p class="center"><em>more than I have since college.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?01c7ae90